let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kHJL1")).then(() => parcelRequire('klL0c'));